export var Weekday;
(function (Weekday) {
    Weekday["Primeday"] = "Primeday";
    Weekday["Centaxday"] = "Centaxday";
    Weekday["Taungsday"] = "Taungsday";
    Weekday["Zhellday"] = "Zhellday";
    Weekday["Benduday"] = "Benduday";
})(Weekday || (Weekday = {}));
export var Festival;
(function (Festival) {
    Festival["FeteWeek"] = "Fete Week";
    Festival["FestivalOfLife"] = "Festival of Life";
    Festival["FestivalOfStars"] = "Festival of Stars";
})(Festival || (Festival = {}));
export var Month;
(function (Month) {
    Month["Elona"] = "Elona";
    Month["Kelona"] = "Kelona";
    Month["Selona"] = "Selona";
    Month["Telona"] = "Telona";
    Month["Nelona"] = "Nelona";
    Month["Helona"] = "Helona";
    Month["Melona"] = "Melona";
    Month["Yelona"] = "Yelona";
    Month["Relona"] = "Relona";
    Month["Welona"] = "Welona";
})(Month || (Month = {}));
//# sourceMappingURL=Types.js.map